export const SENIORS_FETCH = "SENIORS_FETCH";
export const SENIORS_CHECKBOX = "SENIORS_CHECKBOX";
export const RELATIVES_FETCH = "RELATIVES_FETCH";
export const RELATIVES_ADD = "RELATIVES_ADD";
